<template>
  <!-- 新建生产单-工艺单部分 -->
  <div>
    <br>
    <div style="display:flex;">
        <!-- <el-button type="primary" size="small">保存模板</el-button> -->
        <el-form :model="craftOrder" :rules="craftOrderRuler" style="height:40px" ref="craftOrderFormRef"  >
          <el-form-item label=" " prop="orderName" label-width="20px">
            <el-input v-model="craftOrder.orderName" placeholder="请输入内容">
                <template slot="prepend">胚布</template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-input v-model="craftOrder.craftRemarks" placeholder="请输入内容" style="width:100%">
            <template slot="prepend">工艺说明</template>
        </el-input>
    </div><br>
    <el-table :data="craftOrder.craftItems" class="craft-order" :row-style="{height: '0'}"
    :cell-style="{'padding':'0px'}" :header-cell-style="{padding: 0}" border>
      <el-table-column fixed label="梳节" width="50px" prop="combSection" align="center"/>
      <el-table-column label="原料规格" width="80" align="center">
        <template slot-scope="data">
          <input v-model="data.row.materialStandard" class="table-input"/>
        </template>
      </el-table-column>
      <el-table-column label="原料批号" width="80" align="center">
        <template slot-scope="data">
          <input v-model="data.row.materialBatch" class="table-input"/>
        </template>
      </el-table-column>
      <el-table-column label="线圈长度(mm/腊克)" width="130" align="center">
        <template slot-scope="data">
          <input v-model="data.row.coilLength" class="table-input"/>
        </template>
      </el-table-column>
      <el-table-column label="头纹" width="80" align="center">
        <template slot-scope="data">
          <input v-model="data.row.headVeins" class="table-input"/>
        </template>
      </el-table-column>
      <el-table-column label="盘头(个)" width="80" align="center">
        <template slot-scope="data">
          <input v-model="data.row.panHeadNum" class="table-input"/>
        </template>
      </el-table-column>
      <el-table-column label="送纱量" width="80" align="center">
        <template slot-scope="data">
          <input v-model="data.row.sendYarnFeed" class="table-input"/>
        </template>
      </el-table-column>
      <el-table-column label="垫纱记录" align="center">
        <template slot-scope="data">
          <textarea v-model="data.row.padYarnRecord" class="table-input" style="text-align:left"/>
        </template>
      </el-table-column>
      <el-table-column label="穿纱方式" align="center">
        <template slot-scope="data">
          <textarea v-model="data.row.crossYarnWay" class="table-input" style="text-align:left"/>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      craftOrder: {
        orderName: '',
        craftRemarks: '',
        craftItems: [{ combSection: 'GB1' }, { combSection: 'GB2' }, { combSection: 'GB3' }, { combSection: 'GB4' },
          { combSection: 'GB5' }, { combSection: 'GB6' }, { combSection: 'GB7' }, { combSection: 'GB8' }]
      },
      craftTemplate: [],
      craftOrderRuler: {
        orderName: [{ required: true, message: '请输入胚布名称', trigger: 'blur' }]
      },
      craftItemKeys: {
        materialStandard: { value: '原料规格', width: 80 },
        materialBatch: { value: '原料批号', width: 80 },
        coilLength: { value: '线圈长度(mm/腊克)', width: 130 },
        headVeins: { value: '头纹', width: 80 },
        panHeadNum: { value: '盘头(个)', width: 80 },
        sendYarnFeed: { value: '送纱量', width: 80 },
        padYarnRecord: { value: '垫纱记录', width: '' },
        crossYarnWay: { value: '穿纱方式', width: '' }
      }
    }
  },
  methods: {
    // 外部调用，获取填写的工艺单数据
    getCraftOrder() {
      const cloneCraftOrder = this._.cloneDeep(this.craftOrder)
      cloneCraftOrder.craftItems = this.clearNullCarftItem(cloneCraftOrder.craftItems)
      return cloneCraftOrder
    },
    // 外部调用，用以判断用户是否填写输入框的内容
    getValid() {
      this.$refs.craftOrderFormRef.validate(valid => {
        this.valid = valid
      })
      return this.valid
    },
    // 清空为空的工艺对象,只有一个GB的这种
    clearNullCarftItem(craftItems) {
      const formatCraftItems = []
      craftItems.forEach(obj => {
        if (this._.size(obj) <= 1) {
          return
        }
        for (const key in this.craftItemKeys) {
          if (this.utils.isEmpty(obj[key])) {
            obj[key] = ''
          }
        }
        formatCraftItems.push(obj)
      })
      return formatCraftItems
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.table-input {
  width:100%;height:30px;border:0px;outline:none;padding:0;margin:0;
  text-align: center;
}
.el-button {
    margin:6px 10px 0px 0px
}
</style>
